import { ServicesType } from 'utils/globalTypes';

export const SERVICES = {
  alerts: 'alerts',
  vpnInTouch: 'vpnInTouch',
  passwordDefense: 'passwordDefense',
  dboo: 'dataBrokerOptOut',
  passwords: 'passwords',
  digitalVault: 'digitalVault',
  medicalDataMonitoring: 'medicalDataMonitoring',
  darkweb: 'darkweb',
  darkwebScanReport: 'darkwebScanReport',
  passwordScan: 'passwordScan',
  insurance: 'insurance',
  privateSearch: 'privateSearch',
  htmon: 'homeTitleMonitoring',
  creditScore: 'creditScore',
  creditLock: 'creditLock',
} as const;

export const SERVICE_ENTITLEMENTS_MAPPING: Record<ServicesType, string[]> = {
  [SERVICES.alerts]: [
    'authentication_alerts',
    'fouriq',
    'healthcare_data',
    'home_title_monitoring',
    'address_monitoring',
    'public_record_identity_misuse',
    'bank_account_monitoring',
    'credit_monitoring_3b',
    'credit_monitoring_1b',
    'public_record_criminal',
    'public_record_sex_offender',
    'transaction_monitoring',
    'credit_lock',
    'credit_score',
  ],
  [SERVICES.vpnInTouch]: ['vpn_in_touch'],
  [SERVICES.passwordDefense]: ['pango_pwm'],
  [SERVICES.dboo]: ['dboo'],
  [SERVICES.passwords]: ['pango_pwm', 'vault'],
  [SERVICES.digitalVault]: ['pango_pwm', 'vault'],
  [SERVICES.medicalDataMonitoring]: ['healthcare_data'],
  [SERVICES.darkweb]: ['fouriq'],
  [SERVICES.darkwebScanReport]: ['dw_1x_scan'],
  [SERVICES.passwordScan]: ['password_scan'],
  [SERVICES.insurance]: ['insurance'],
  [SERVICES.privateSearch]: ['private_browser', 'private_search'],
  [SERVICES.htmon]: ['htmon'],
  [SERVICES.creditScore]: ['efxvs', 'tuvs', 'xpnvs'],
  [SERVICES.creditLock]: ['xpncl'],
};
